import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Link } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { Section } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useTestId, useMediumLink } from "@/hooks";
import { useSellerLeadLink } from ".";
import { Box } from "@gemini/core";
import { CheckFilledCircleIcon, ArrowRightIcon } from "@gemini/icons";
export const SellerLeadTeaser = () => {
    const testId = useTestId("Sections.SellerTeaser");
    const { t } = useI18n();
    const { funnel: funnelUrl, landing: landingUrl } = useSellerLeadLink();
    const { sellerLeadTeaserRef } = useRefsContext();
    const mediumLink = useMediumLink("SellerLead");
    const items = [
        t("seller_lead_teaser.list_item_one"),
        t("seller_lead_teaser.list_item_two"),
        t("seller_lead_teaser.list_item_three"),
    ];
    return funnelUrl ? (_jsx(Section, { ref: sellerLeadTeaserRef, testId: testId, unsafeClassname: "HideOnPrint", children: _jsx(Card, { borderRadius: "16", hasPadding: false, children: _jsxs(Box, { padding: "spacing.24", paddingTop: "spacing.16", children: [_jsxs(Box, { as: "h2", typography: "typography.headline.20.bold", textAlign: "center", margin: "spacing.none", marginBottom: "spacing.16", display: "flex", flexWrap: "wrap", justifyContent: "center", children: [_jsx(Box, { as: "span", marginRight: "spacing.8", children: t("seller_lead_teaser.headline_one") }), _jsx(Box, { as: "span", children: t("seller_lead_teaser.headline_two") })] }), _jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: {
                            "breakpoint.base": "start",
                            "breakpoint.md": "center",
                            "breakpoint.lg": "start",
                            "breakpoint.xl": "center",
                        }, flexDirection: {
                            "breakpoint.base": "column",
                            "breakpoint.md": "row",
                            "breakpoint.lg": "column",
                            "breakpoint.xl": "row",
                        }, gap: "spacing.24", children: [_jsx(Box, { display: "flex", gap: "spacing.8", flexDirection: "column", children: items.map((item) => (_jsxs(Box, { display: "flex", gap: "spacing.4", children: [_jsx(CheckFilledCircleIcon, {}), _jsx(Box, { children: item })] }, item))) }), _jsx(Button, { isFullWidth: {
                                    "breakpoint.base": true,
                                    "breakpoint.md": false,
                                    "breakpoint.lg": true,
                                    "breakpoint.xl": false,
                                }, icon: ArrowRightIcon, iconPosition: "end", size: "48", isExternal: true, "data-tracking": mediumLink, href: funnelUrl, testId: `${testId}.Content`, children: t("seller_lead_teaser.cta") })] }), _jsx(Box, { marginTop: {
                            "breakpoint.base": "spacing.24",
                            "breakpoint.md": "spacing.16",
                            "breakpoint.lg": "spacing.24",
                            "breakpoint.xl": "spacing.16",
                        }, width: "fit-content", children: _jsx(Link, { isExternal: true, href: landingUrl, "data-tracking": mediumLink, children: t("seller_lead_teaser.link") }) })] }) }) })) : null;
};
